import { Icon } from "@iconify/react";
import ProfileBar from "../../components/path/profile/profileBar";
import { useParams } from "react-router-dom";
import { useState } from "react";
import { useEffect } from "react";
import { profileClient } from "../../network/lib/profile";

function StarRating(props) {
    const { advice } = props;
  
    const renderStars = () => {
      const stars = [];
      for (let i = 0; i < advice; i++) {
        stars.push(<Icon key={i} icon="material-symbols:star" />);
      }
      return stars;
    };
  
    return <>{renderStars()}</>;
}

function StringWithNewlinesToParagraphs({ text }) {
    if (!text) {
        return null;
    }
    const paragraphs = text
        .split("\n")
        .map((line, index) => <p key={index}>{line}</p>);

    return <>{paragraphs}</>;
}

function ProfilePage() {
    const { officeName, expertId } = useParams();
    const [expertData, expertDataSet] = useState([]);
    const baseUrl = window.location.origin;

    const redirectPayment = () => {
        const path = "/" + officeName + "/client/payement";
        window.open(baseUrl + path, '_blank', 'noreferrer');
    };

    useEffect(() => {
        profileClient.expert.getPublicProfile(expertId).then(res =>{ 
            console.log(res.data)
            expertDataSet(res.data)})
    }, [])

    return (
        <div className="modern-page expert-profile-page">
            <div className="expert-profile-header">
                <div className="expert-profile-info">
                    <ProfileBar 
                        name={expertData["name"]}
                        advice={expertData["advice"]}
                        scores={expertData["scores"]}
                        callCount={expertData["callCount"]}
                        imageProfile={expertData["imageProfile"]}
                        benefits={expertData["benefits"]}
                        expertId={expertId}
                        officeName={officeName}
                        isWebhook={true}
                    />
                </div>
            </div>

            <div className="expert-profile-content">
                <div className="modern-card">
                    <div className="card-header">
                        <h3 className="card-title">À propos de cet expert</h3>
                        <p className="card-subtitle">Découvrez son parcours et ses spécialités</p>
                    </div>
                    <div className="card-body">
                        <StringWithNewlinesToParagraphs
                            text={expertData["description"]}
                        />
                    </div>
                </div>

                <div className="modern-card">
                    <div className="card-header">
                        <h3 className="card-title">Forfaits disponibles</h3>
                        <p className="card-subtitle">Choisissez la durée qui vous convient</p>
                    </div>
                    <div className="card-body">
                        {expertData["plans"] && expertData["plans"].length > 0 ? (
                            <div className="modern-grid grid-4">
                                {expertData["plans"].map((plan, index) => {
                                    return (
                                        <div key={index} className="plan-card">
                                            <div className="plan-header">
                                                <h4 className="plan-name">{plan["name"]}</h4>
                                            </div>
                                            <div className="plan-details">
                                                <div className="plan-duration">
                                                    <Icon icon="ic:sharp-access-time" />
                                                    <span>{plan["minutes"]} Minutes</span>
                                                </div>
                                                <div className="plan-price">{plan["prices"]} €</div>
                                            </div>
                                            <button 
                                                className="modern-button primary plan-button"
                                                onClick={redirectPayment}
                                            >
                                                Choisir ce forfait
                                            </button>
                                        </div>
                                    )
                                })}
                            </div>
                        ) : (
                            <div className="empty-state">
                                <p>Aucun forfait disponible</p>
                            </div>
                        )}
                    </div>
                </div>

                <div className="modern-grid grid-2">
                    <div className="modern-card">
                        <div className="card-header">
                            <h3 className="card-title">Disponibilités</h3>
                            <p className="card-subtitle">Horaires de consultation</p>
                        </div>
                        <div className="card-body">
                            {expertData["plannings"] && expertData["plannings"].length > 0 ? (
                                expertData["plannings"].map((planning, index) => {
                                    return (
                                        <div key={index} className="availability-item">
                                            <div className="availability-day">
                                                <span className="day-name">{planning["name"]}</span>
                                                <span className="day-date">({planning["date"]})</span>
                                            </div>
                                            <div className="availability-hours">
                                                {planning["schedules"].map((schedule, index) => {
                                                    return (
                                                        <span key={index} className="hour-slot">
                                                            {schedule}
                                                        </span>
                                                    )
                                                })}
                                            </div>
                                        </div>
                                    )
                                })
                            ) : (
                                <div className="empty-state">
                                    <p>Aucune disponibilité renseignée</p>
                                </div>
                            )}
                        </div>
                    </div>
                </div>

                <div className="modern-card">
                    <div className="card-header">
                        <h3 className="card-title">Avis clients</h3>
                        <p className="card-subtitle">Ce que disent les clients de cet expert</p>
                    </div>
                    <div className="card-body">
                        {expertData["comments"] && expertData["comments"].length > 0 ? (
                            expertData["comments"].map((comment, index) => {
                                return (
                                    <div key={index} className="comment-item">
                                        <div className="comment-header">
                                            <div className="comment-author">{comment["clientName"]}</div>
                                            <div className="comment-rating">
                                                <div className="stars">
                                                    <StarRating advice={comment["scores"]} />
                                                </div>
                                                <span className="comment-date">{comment["date"]}</span>
                                            </div>
                                        </div>
                                        {comment["clientMessage"] ? (
                                            <div className="comment-message">
                                                <p>{comment["clientMessage"]}</p>
                                            </div>
                                        ) : ""}
                                        {comment["expertMessage"] ? (
                                            <div className="comment-response">
                                                <div className="response-header">
                                                    <span className="response-title">
                                                        Réponse de {comment["expertName"]} :
                                                    </span>
                                                </div>
                                                <p className="response-message">{comment["expertMessage"]}</p>
                                            </div>
                                        ) : ""}
                                    </div>
                                )
                            })
                        ) : (
                            <div className="empty-state">
                                <p>Aucun avis pour le moment</p>
                            </div>
                        )}
                    </div>
                </div>
            </div>

            <footer className="modern-footer">
                <div className="footer-content">
                    <p>
                        A service provided by <a href="https://vooxhub.com" target="_blank" rel="noopener noreferrer">VooxHub</a> - 2023 © All rights reserved
                    </p>
                    <p>
                        Developed by <a href="https://shield4Cloud.com" target="_blank" rel="noopener noreferrer">Shield4Cloud</a>
                    </p>
                </div>
            </footer>
        </div>
    );
}

export default ProfilePage;